/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateDocumentSecurityRequestDto { 
    /**
     * New security level for the document
     */
    newSecurity: UpdateDocumentSecurityRequestDto.NewSecurityEnum;
    /**
     * User making the security change
     */
    modifiedBy?: string;
}
export namespace UpdateDocumentSecurityRequestDto {
    export type NewSecurityEnum = 'public' | 'confidential' | 'restricted' | 'very_restricted';
    export const NewSecurityEnum = {
        Public: 'public' as NewSecurityEnum,
        Confidential: 'confidential' as NewSecurityEnum,
        Restricted: 'restricted' as NewSecurityEnum,
        VeryRestricted: 'very_restricted' as NewSecurityEnum
    };
}


